import React from 'react'
import { Box, CardHeader, Typography } from '@mui/material'
import { IoChevronForwardOutline } from 'react-icons/io5'

import { stMob } from './styleBS'

export default function BttSetting({ Icon, title, subTitle, onClick }) {
  return (
    <Box sx={stMob.containBttSettings} onClick={() => onClick()}>
      <CardHeader
        sx={stMob.containHeader}
        avatar={Icon && <Icon size={30} color='ff7043' />}
        title={<Typography sx={stMob.titleBtt}>{title}</Typography>}
        subheader={<Typography sx={stMob.labelbtt}>{subTitle}</Typography>}
      />
      <IoChevronForwardOutline size={25} color='ff7043' />
    </Box>
  )
}
